import { render, staticRenderFns } from "./Bpu.vue?vue&type=template&id=367b9116&scoped=true"
import script from "./Bpu.vue?vue&type=script&lang=js"
export * from "./Bpu.vue?vue&type=script&lang=js"
import style0 from "./Bpu.vue?vue&type=style&index=0&id=367b9116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367b9116",
  null
  
)

export default component.exports